exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-cards-due-empty__empty__3gi8R{align-items:center;background-color:#ebeef0;border-radius:4px;color:#6b808c;display:flex;height:24px;justify-content:center;margin:-8px 8px 40px;padding:8px}.team-cards-due-empty__emptyToday__32zvn{align-items:center;border-top:1px solid #ebeef0;display:flex;flex-direction:column;margin:-8px 8px 40px;padding:16px}.team-cards-due-empty__image__1XZuu{display:block}.team-cards-due-empty__title__WBsd9{font-size:16px;font-weight:700;margin-top:12px}.team-cards-due-empty__subtitle__1m0e6{color:#6b808c}", ""]);

// exports
exports.locals = {
	"empty": "team-cards-due-empty__empty__3gi8R",
	"emptyToday": "team-cards-due-empty__emptyToday__32zvn",
	"image": "team-cards-due-empty__image__1XZuu",
	"title": "team-cards-due-empty__title__WBsd9",
	"subtitle": "team-cards-due-empty__subtitle__1m0e6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2445/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/team-cards-due-empty.less
// module id = 9jb1
// module chunks = 12